import { useContext } from "react";
import { RankifierDesinationsContext } from "../contexts/rankifier/rankifierDestinations";

export const useRankifierDestinations = () => {
  const context = useContext(RankifierDesinationsContext);
  if (!context) {
    throw new Error("useRankifierDestinations must be used within a RankifierContextProvider");
  }
  return context;
};
